import axios from 'axios'
import _ from 'underscore'
import store from '../state/store'
import {updateLocation, getQueryStringHash} from '../nav'

store.on('ui:enquiry:tab_key', function(enquiry_tab_key) {
  const enquiry = store.get().ui.enquiry

  enquiry.set({tab_key: enquiry_tab_key})
  store.emit('ui:query_string:refresh')

  if (enquiry_tab_key == 'activity') {
    store.emit('enquiry:comments:index', enquiry.id)
  }
})

store.on('ui:enquiry:lesson_plan_id', function(lesson_plan_id) {
  store.get().ui.enquiry.set({
    lesson_plan_id,
    lesson_plan_tab: 'lesson_setup',
    tutor_id: null
  })
})

store.on('ui:enquiry:lesson_plan:tutor_id', function(lesson_plan_id, tutor_id) {
  store.get().ui.enquiry.set({tutor_id})
})

store.on('ui:lesson_plan:tab', function(lesson_plan_tab) {
  store.get().ui.enquiry.set({lesson_plan_tab})
  const currentSearch = getQueryStringHash()
  currentSearch.lpt = lesson_plan_tab
  updateLocation({search: currentSearch})
})

store.on('ui:query_string:refresh', function() {
  const currentSearch = getQueryStringHash()
  currentSearch.e = store.get().enquiry.id
  currentSearch.t = store.get().ui.enquiry.tab_key

  const lesson_plan_tab = store.get().ui.enquiry.lesson_plan_tab
  if (lesson_plan_tab && lesson_plan_tab !== 'lesson_setup') {
    currentSearch.lpt = lesson_plan_tab
  } else {
    delete currentSearch.lpt
  }

  updateLocation({search: currentSearch})
})

store.on('ui:enquiry:smser:toggle', function() {
  const smser = store.get().ui.enquiry.smser

  if (smser.open) {
    store.get().ui.enquiry.smser.set({open: false, content: ''})
  } 
  else {
    store.get().ui.enquiry.smser.set({open: true, content: ''})
  }
})

store.on('ui:enquiry:smser:content', function(value) {
  store.get().ui.enquiry.smser.set({content: value})
})

store.on('ui:enquiry:buttons:support_handover', function(params = {}) {
  store.get().ui.enquiry.buttons.support_handover.set(params)
})

store.on('ui:enquiry:buttons:deactivate', function(params = {}) {
  store.get().ui.enquiry.buttons.deactivate.set(params)
})

store.on('ui:enquiry:buttons:reactivate', function(params = {}) {
  store.get().ui.enquiry.buttons.reactivate.set(params)
})

// tutor proposer

store.on('ui:tutor_proposer:open', function(params = {}) {
  const tutor_result = params.tutor_result
  const tutoring_job = params.tutoring_job

  if (tutor_result && (tutor_result.tutor.id === store.get().ui.tutor_proposer.viewing_tutor_id)) {
    return
  }

  store.get().ui.tutor_proposer.set({
    viewing_tutor_id: tutor_result.tutor.id,
    tutoring_job_id: tutoring_job.id
  })
})

store.on('ui:tutor_proposer:close', function() {
  store.get().ui.tutor_proposer.set({
    viewing_tutor_id: '',
    tutoring_job_id: ''
  })
})

// tutor acceptor

store.on('ui:tutor_acceptor:open', function(params = {}) {
  const tutor_result = params.tutor_result
  const tutoring_job = params.tutoring_job

  if (tutor_result && (tutor_result.tutor.id === store.get().ui.tutor_acceptor.viewing_tutor_id)) {
    return
  }

  store.get().ui.tutor_acceptor.set({
    viewing_tutor_id: tutor_result.tutor.id,
    tutoring_job_id: tutoring_job.id,
    position_ids: []
  })
})

store.on('ui:tutor_acceptor:close', function() {
  store.get().ui.tutor_acceptor.set({
    viewing_tutor_id: '',
    tutoring_job_id: '',
    position_ids: []
  })
})

store.on('ui:tutor_acceptor:toggle_position', function(tutoring_job_position_id) {
  let position_ids
  const state = store.get().ui.tutor_acceptor

  if (state.position_ids.includes(tutoring_job_position_id)) {
    position_ids = _.select(state.position_ids, position_id => position_id !==tutoring_job_position_id)
    state.set({position_ids})
  } 
  else {
    state.position_ids.push(tutoring_job_position_id)
  }
})

// tutor rejector

store.on('ui:tutor_rejector:open', function(params = {}) {
  const tutor_result = params.tutor_result
  const tutoring_job = params.tutoring_job

  if (tutor_result && (tutor_result.tutor.id ===store.get().ui.tutor_rejector.viewing_tutor_id)) {
    return
  }

  store.get().ui.tutor_rejector.set({
    viewing_tutor_id: tutor_result.tutor.id,
    tutoring_job_id: tutoring_job.id
  })
})

store.on('ui:tutor_rejector:close', function() {
  store.get().ui.tutor_rejector.set({
    viewing_tutor_id: '',
    tutoring_job_id: ''
  })
})

// tutor searcher

store.on('ui:tutor_searcher:open', function(tutoring_job_id) {
  store.get().ui.tutor_searcher.set({
    tutoring_job_id,
    position_ids: []
  })
})

store.on('ui:tutor_searcher:close', function() {
  store.get().ui.tutor_searcher.set({
    tutoring_job_id: '',
    position_ids: []
  })
})

store.on('ui:tutor_searcher:toggle_position', function(tutoring_job_position_id) {
  const state = store.get().ui.tutor_searcher

  if (state.position_ids.includes(tutoring_job_position_id)) {
    const position_ids = _.select(state.position_ids, function(position_id) {
      return position_id !== tutoring_job_position_id
    })

    state.set({position_ids: position_ids})
  } 
  else {
    state.position_ids.push(tutoring_job_position_id)
  }
})

// tutor smser

store.on('ui:tutor_smser:open', function(params = {}) {
  if (params.tutor_id ===store.get().ui.tutor_smser.tutor_id) {
    return
  }

  store.get().ui.tutor_smser.set({
    tutor_id: params.tutor_id,
    tutoring_job_id: params.tutoring_job_id,
    content: ''
  })
})

store.on('ui:tutor_smser:close', function() {
  store.get().ui.tutor_smser.set({
    tutor_id: '',
    tutoring_job_id: '',
    content: ''
  })
})

// request placement

store.on('ui:request_placement:open', function(tutoring_job_id, position_ids = []) {
  if (tutoring_job_id ===store.get().ui.request_placement.tutoring_job_id) {
    return
  }

  store.get().ui.request_placement.set({
    tutoring_job_id,
    request_tutor_search: true,
    position_ids: position_ids,
    placement_manager_id: '',
    placement_managers: [],
    reserved_for_minutes: 240
  })

  store.emit('placement_managers:index')
})

store.on('ui:request_placement:close', function() {
  store.get().ui.request_placement.set({
    tutoring_job_id: '',
    request_tutor_search: true,
    position_ids: [],
    placement_manager_id: '',
    placement_managers: [],
    reserved_for_minutes: 240
  })
})

store.on('ui:request_placement:select_manager', function(placement_manager_id) {
  store.get().ui.request_placement.set({placement_manager_id})
})

store.on('ui:request_placement:select_minutes', function(reserved_for_minutes) {
  store.get().ui.request_placement.set({reserved_for_minutes: parseInt(reserved_for_minutes, 10) || 240})
})

store.on('ui:request_placement:toggle_search', function(value) {
  store.get().ui.request_placement.set({request_tutor_search: value})
})

store.on('ui:request_placement:toggle_position', function(tutoring_job_position_id) {
  const state = store.get().ui.request_placement

  if (state.position_ids.includes(tutoring_job_position_id)) {
    const position_ids = _.select(state.position_ids, function(position_id) {
      return position_id !== tutoring_job_position_id
    })

    state.set({position_ids})
  } 
  else {
    state.position_ids.push(tutoring_job_position_id)
  }
})

store.on('ui:tutor_smser:update', function(params = {}) {
  store.get().ui.tutor_smser.set(params)
})

store.on('ui:google_map:load', function(enquiry_id) {
  window.loadGoogleMapsScript(
    function() { 
      store.get().ui.google_map.set({loaded: true})
    }
  )
})

store.on('ui:tutoring_job:tutor_results_filter', function(value) {
  store.get().ui.tutoring_job.set({tutor_results_filter: value})
})

store.on('ui:tutoring_job:tutor_experience_level', function(value) {
  store.get().ui.tutoring_job.set({tutor_experience_level: value})
})

store.on('ui:tutoring_job:tutor_active_within', function(value) {
  store.get().ui.tutoring_job.set({tutor_active_within: value})
})

store.on('ui:tutoring_job:onboarded_after', function(value) {
  store.get().ui.tutoring_job.set({onboarded_after: value})
})

store.on('ui:tutoring_job:tutor_search_bio', function(value) {
  store.get().ui.tutoring_job.set({tutor_search_bio: value})
})

store.on('ui:enquiry:result:click', function(enquiry_id) {
  store.get().set({searched_enquiries: []})
  store.emit('enquiries:show', enquiry_id)
})

store.on('ui:lead:smser:toggle', function() {
  const smser = store.get().ui.lead.smser

  if (smser.open) {
    store.get().ui.lead.smser.set({open: false, content: ''})
  } 
  else {
    store.get().ui.lead.smser.set({open: true, content: ''})
  }
})

store.on('ui:lead:smser:content', function(value) {
  store.get().ui.lead.smser.set({content: value})
})

store.on('ui:mailer:open', function(params = {}) {
  const mailer = store.get().ui.mailer

  if ((params.related_to_type === mailer.related_to_type) && (params.related_to_id === mailer.related_to_id)) {
    mailer.set({
      open: true
    })
  }
  else {
    mailer.set({
      open: true, 
      related_to_type: params.related_to_type,
      related_to_id: params.related_to_id,
      email: {}
    })
  }
})

store.on('ui:mailer:close', function() {
  store.get().ui.mailer.set({
    open: false
  })
})

store.on('ui:mailer:change', function(params = {}) {
  store.get().ui.mailer.set(params)
})

store.on('ui:whatsapper:open', function(params = {}) {
  const whatsapper = store.get().ui.whatsapper
  const is_related_to_type = (params.related_to_type === whatsapper.related_to_type)
  const is_related_to_id = (params.related_to_id === whatsapper.related_to_id)
  const is_recipient_id = (params.recipient_id === whatsapper.recipient_id)
  const is_recipient_type = (params.recipient_type === whatsapper.recipient_type)

  if ((is_related_to_type) && (is_related_to_id) && (is_recipient_id) && (is_recipient_type)) {
    whatsapper.set({
      open: true
    })
  }
  else {
    whatsapper.set({
      open: true, 
      related_to_type: params.related_to_type,
      related_to_id: params.related_to_id,
      recipient_type: params.recipient_type,
      recipient_id: params.recipient_id,
      whatsapp: {}
    })
  }
})

store.on('ui:whatsapper:close', function() {
  store.get().ui.whatsapper.set({
    open: false
  })
})

store.on('ui:whatsapper:change', function(params = {}) {
  store.get().ui.whatsapper.set(params)
})

store.on('ui:whatsapper:send', function(params = {}) {
  axios.post("/api/sales/whatsapps", params)
  .then((response) => {
    showMessage('WhatsApp sent.')

    store.get().ui.whatsapper.set({
      open: false,
      related_to_type: null,
      related_to_id: null,
      recipient_type: null,
      recipient_id: null,
      template_name: 'draft',
      whatsapp: {}
    })

    if (params.related_to_type == 'Lead') {
      store.emit('lead:comments:index', params.related_to_id)
    }
    else if (params.related_to_type == 'Enquiry') {
      store.emit('enquiry:comments:index', params.related_to_id)
    }
  })
  .catch((error) => {
    handleError(error)
  })
})


store.on('ui:sign_out', function() {
  axios.get('/api/sales/users/sign_out')
  .then((response) => {
    axios.delete('/api/sales/sessions')
  })
  .then((response) => {
    window.location = '/'
  })
  .catch((error) => {
    handleError(error)
  })
})
